import { useEffect } from 'react';
import { create } from 'zustand';

interface CommandPaletteStore {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setOpen: (next: boolean) => void;
}

/**
 * Estado global del Command Palette. Vive en `shared/lib` para que el
 * trigger (en topbar) y el palette (en su propio slice) lo lean sin
 * cruzar slices del mismo layer.
 */
export const useCommandPaletteStore = create<CommandPaletteStore>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setOpen: (next) => set({ isOpen: next }),
}));

/**
 * Atajo Cmd+K / Ctrl+K como toggle global. Se monta una sola vez (en el shell).
 */
export function useCommandPaletteShortcut(): void {
  const toggle = useCommandPaletteStore((s) => s.toggle);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key.toLowerCase() === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        toggle();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [toggle]);
}
